import { captureException } from '@sentry/react';
import { useState } from 'react';
/** For interacting with the browser local storage API.
 *
 * @returns {Array} this returns [storageValue, setLocalStorageValue] for the provided key.
 */
const useLocalStorage = (key, initialValue) => {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            // If error also return initialValue
            captureException(error, {
                extra: {
                    file: 'useLocalStorage',
                    storageKey: key,
                },
            });
            return initialValue;
        }
    });
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value) => {
        try {
            // Save state
            setStoredValue(value);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(value));
        }
        catch (error) {
            // A more advanced implementation would handle the error case
            captureException(error, {
                extra: {
                    file: 'useLocalStorage',
                    storageKey: key,
                },
            });
        }
    };
    return [storedValue, setValue];
};
export default useLocalStorage;
